const GTM_ID = "GTM-TSCN58BW";

let analyticsAllowed = false;
let gtmRequested = false;

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
}

function consentState(analytics) {
  return {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  };
}

function removeAnalyticsCookies() {
  const names = document.cookie
    .split(";")
    .map((part) => part.trim().split("=")[0])
    .filter((name) => name === "_ga" || name.startsWith("_ga_"));
  names.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    document.cookie = `${name}=; Max-Age=0; Path=/; Domain=menstage.hu; SameSite=Lax`;
  });
}

function loadGtm() {
  if (
    gtmRequested ||
    document.querySelector(`script[data-menstage-gtm="${GTM_ID}"]`)
  ) {
    return;
  }
  gtmRequested = true;
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const script = document.createElement("script");
  script.async = true;
  script.dataset.menstageGtm = GTM_ID;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
  document.head.appendChild(script);
}

ensureDataLayer();
window.gtag("consent", "default", consentState(false));
window.gtag("set", "ads_data_redaction", true);

export function setAnalyticsConsent(allowed) {
  ensureDataLayer();
  analyticsAllowed = allowed === true;
  window.gtag("consent", "update", consentState(analyticsAllowed));
  if (analyticsAllowed) loadGtm();
  else removeAnalyticsCookies();
}
